import React, {useCallback} from 'react';
import './ColorUnit.sass';

export const ColorUnit = ({
  color,
  height = 32,
  width = 32,
  onClick,
  square = false,
  isActive,
  dataQaId,
  disabled = false,
}) => {
  const onClickHandler = useCallback(() => {
    onClick && onClick(color);
  }, []);

  return (
    <div
      role="button"
      className={`colors_unit ${onClick && 'colors_unit--clickable'} ${
        square && 'colors_unit--square'
      } ${isActive && 'colors_unit--active'}
      ${disabled && 'colors_unit--disabled'}`}
      style={{backgroundColor: color, height, width}}
      title={color}
      onClick={disabled ? undefined : onClickHandler}
      data-qa-id={dataQaId}
    />
  );
};
